import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage, updateStatusRoute } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { updateWalkthroughStatus } from '@utils/updateOnboardingStatus';

type UseUpdateStatusProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useUpdateStatus = ({
  setAlertText = () => {},
  onSuccess = () => {},
}: UseUpdateStatusProps) => {
  const client = useQueryClient();

  const { mutate: updateStatus, isLoading: isUpdatingStatus } = useMutation({
    mutationFn: (variables: {
      has_standard_positions?: boolean;
      has_mission_statement?: boolean;
      has_facebook_page_id?: boolean;
      has_shared_page?: boolean;
      has_image?: boolean;
      has_cover_image?: boolean;
      has_job_postings?: boolean;
      auto_save_applications?: boolean;
      auto_interview_invite?: boolean;
      has_application_questions?: boolean;
      walkthrough_status?: number;
      has_address?: boolean;
      wotc_completed?: boolean;
      has_work_history?: boolean;
      has_education?: boolean;
      has_references?: boolean;
    }) =>
      axiosInstance.post(updateStatusRoute, variables).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setAlertText(data.message);
      } else {
        setAlertText('');
        client.invalidateQueries([profileKey]);
        if (data?.object?.company && data?.object?.walkthrough_status !== 2) {
          updateWalkthroughStatus(
            data?.object?.company.plan,
            data?.object,
            undefined,
            updateStatus,
          );
        }
        onSuccess();
      }
    },
    onError: () => {
      setAlertText(errorMessage);
    },
  });

  return {
    updateStatus,
    isUpdatingStatus,
  };
};
